import React from "react";
import PropTypes from "prop-types";

import FlagFootballProgramCard from "./FlagFootballProgramCard";

function FlagFootballProgramGrid({ programs }) {
  if (!programs || programs.length === 0) {
    return (
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-8 text-center">
            <h3 className="futuraPTBold">
              UA Flag Football Coming Soon!
            </h3>

            <p className="futuraPTBook mb-0">
              We're currently working to schedule our next
              Flag Football program. Please check back soon
              for upcoming dates and registration information.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
    <div className="container p-3">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-8 text-center">
            <h2 className="futuraPTBold">
              UA Flag Football Registration Now Closed
            </h2>
          </div>
        </div>
      </div>
    <div className="container basketball-program-grid">
      <div className="row g-4 justify-content-center">
        {programs.map((program) => (
          <div
            className="col-12 col-md-6 col-xl-4 d-flex"
            key={program.id}
          >
            <FlagFootballProgramCard
              program={program}
            />
          </div>
        ))}
      </div>
    </div>
    </>
  );
}

FlagFootballProgramGrid.propTypes = {
  programs: PropTypes.arrayOf(
    PropTypes.object
  ).isRequired
};

export default FlagFootballProgramGrid;